import { External } from "components/icons/generated";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellLink from "ds/components/Table/Row/CellLink";
import TableCellText from "ds/components/Table/Row/CellText";
import { VcsProvider } from "types/generated";

import { ModulePullRequestsTablePullRequestCellProps } from "../types";
import ModulePullRequestsTableGroupCell from "../../GroupCell";

const ModulePullRequestsTablePullRequestAuthorCell = ({
  item: pullRequest,
  moduleProvider,
  ...cellProps
}: ModulePullRequestsTablePullRequestCellProps) => {
  const { authorLogin } = pullRequest;

  return (
    <ModulePullRequestsTableGroupCell item={pullRequest} {...cellProps}>
      {!authorLogin && <TableCellEmpty />}

      {!!authorLogin && moduleProvider === VcsProvider.Github && (
        <TableCellLink
          variant="primary"
          target="_blank"
          endIcon={External}
          href={`https://github.com/${authorLogin}`}
        >
          {authorLogin}
        </TableCellLink>
      )}

      {!!authorLogin && moduleProvider !== VcsProvider.Github && (
        <TableCellText>{authorLogin}</TableCellText>
      )}
    </ModulePullRequestsTableGroupCell>
  );
};

export default ModulePullRequestsTablePullRequestAuthorCell;
